const faqData = [
  {
    id: 1,
    question: 'Is it safe to give blood?',
    ans: 'Yes. Donating blood is safe. The supplies used to collect blood are sterile and only used once.',
  },
  {
    id: 2,
    question: 'Can I donate blood?',
    ans: 'To donate blood, you must weigh at least 110 pounds (about 50 kilograms) and be at least 16 or 17 years old, depending on the law in your country. You must be in good health and able to pass the physical and a confidential health-history assessment to help make sure blood donation is safe for both you and the recipient of the blood.',
  },
  {
    id: 3,
    question: 'Can I donate if I have a cold, flu or fever?',
    ans: 'No. To donate, you must be symptom-free from cold, flu or fever on the day of donation.',
  },
  {
    id: 4,
    question: "I'm taking medications. Can I still donate blood?",
    ans: "Many medications are acceptable. Consult your physician to be sure you're healthy enough to donate and ask your community blood center medical staff if you have questions about your eligibility. Do not assume that you are ineligible without inquiring first.",
  },
  {
    id: 5,
    question: 'Will recent vaccinations make me ineligible to donate blood?',
    ans: "Before donating, eat a healthy meal and drink plenty of water. Go to your donation appointment well rested and wearing a shirt with sleeves that can be rolled up above your elbows. Bring your donor card, driver's license or two other forms of ID.",
  },
  {
    id: 6,
    question: 'How can I prepare to donate blood?',
    ans: 'Recent vaccinations may prevent you from donating blood. Flu vaccines do no make you ineligible. Contact your blood center to request further information.',
  },
  {
    id: 7,
    question: 'Are the health history questions necessary every time?',
    ans: 'Yes. Screening questions must be asked of all donors at each donation.',
  },
  {
    id: 8,
    question: 'How long does it take to give blood?',
    ans: 'The process for whole blood donation usually takes about one hour with the collection itself usually lasting only about 10 minutes. Expect to spend about two hours for an apheresis platelet collection. The donation process includes registration, a brief medical screening, blood collection, and refreshments.',
  },
  {
    id: 9,
    question: 'How much blood do I have in my body?',
    ans: 'Women have about 10 pints, and men about 12 pints of blood in their bodies.',
  },
  {
    id: 10,
    question: 'How often can I give?',
    ans: 'You must wait at least eight weeks (56 days) between donations of whole blood and 16 weeks (112 days) between Power Red donations. Whole blood donors can donate up to 6 times a year. Platelet apheresis donors may give every 7 days up to 24 times per year. Regulations are different for those giving blood for themselves (autologous donors).',
  },
  {
    id: 11,
    question: 'How long will it take to replenish the pint of blood I donate?',
    ans: 'The plasma from your donation is replaced within about 24 hours. Red cells need about four to six weeks for complete replacement. That’s why at least eight weeks are required between whole blood donations.',
  },
]

export default faqData
